//* #region ----------------------------------------------- Types

import type { MyComponentTypes } from "haq"

//Component Dependencies (injected slots), possibly null
type D = MU_InputField

type T = MU_MyInput

type X = MyComponentTypes<T>
type Y = MyComponentTypes<D>
type C = T["MyInput"]

//* #endregion ----------------------------------------------- Types

//* #region -----------------------------------------------  Module Imports (only utility/helper modules)

import { $, TypedComponent, createClone, defineComponent } from "haq"

//* #endregion -----------------------------------------------  Module Imports (only utility/helper modules)

export class MyInput extends HTMLElement {
	private Component: ReturnType<typeof TypedComponent<C>>
	private Input: Y["InputField"]
	private ErrorTemplate: X["InputErrorTemplate"]

	constructor() {
		super()

		this.Component = TypedComponent<C>(this)
		this.Input = $<D["InputField"]>(this, ".input-field")[0]
		this.ErrorTemplate = $<T["InputErrorTemplate"]>(this, "[x_selector='inputErrorTemplate']")[0]

		this._init()
	}

	//* ---------- Initialize -----------------------------------------------

	private _init() {
		this.Input.addEventListener("focus", () => this.Component.setAttribute("d_focus", true))
		this.Input.addEventListener("blur", () => {
			if (this.Input.value === "") this.Component.removeAttribute("d_focus")
		})
		this.Input.addEventListener("input", () => this._checkValidity())
		this.Input.addEventListener("focusout", () => this._checkValidity())

		//handle chrome auto-fill not triggering value change until human interaction
		setTimeout(() => {
			if (this.Input.matches(":autofill")) {
				this.Component.setAttribute("d_focus", true)
			}
		}, 10)
	}

	private _toggleInvalidState(isInvalid: boolean) {
		if (isInvalid) {
			this.Component.setAttribute("d_invalid", true)
			this._showError()
		} else {
			this.Component.removeAttribute("d_invalid")
			this._hideError()
		}
	}

	private _checkValidity() {
		if (!this.Input.checkValidity()) this._toggleInvalidState(true)
		else this._toggleInvalidState(false)
	}

	//* ---------- Show/Hide Error -----------------------------------------------

	private _showError() {
		const ErrorEl = $<T["InputError"]>(this, ".input-error")[0]
		if (ErrorEl) return

		const Clone = createClone(this.ErrorTemplate.content, true)
		this.append(Clone)
	}

	private _hideError() {
		const ErrorEl = $<T["InputError"]>(this, ".input-error")[0]
		if (ErrorEl) ErrorEl.remove()
	}
}

export default function MyInputInit() {
	defineComponent<C>("my-input", MyInput)
}
